//var url = "http://localhost:30475/User/ActionInfo"
// 通信模式
// server-proxy
// access-control
import utils from '../utils'
export default {
    online: {
        fileUrl: {
            host: 'images.ecsweb.jinyantrip.net',
            proxy: 'images.ecsweb.jinyantrip.net',
            prefix: ''
        },
    },
    isOnline: false,
    isHttps: false,
    isProxy: false,
    getUrl(name, url) {
        var apicfg = this.online[name] || {
            prefix: name
        };
        return '/api'.concat('/', apicfg['prefix'], utils.startWith(url, '/') ? '' : '/', url);
    }
}



// WEBPACK FOOTER //
// ./src/apis/config.js